// components/Modals.js
import React, {forwardRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import UploadModalContent from './upload-modal/upload-modal';
import Spreadsheet from 'react-spreadsheet';
import CreateCreditLetterModalContent from './create-report-modal/create-report-modal';
import './modal.scss'

export const UploadModal = ({ report, item, show, onClose }) => (
  <Modal show={show} onHide={onClose} dialogClassName="maker-upload-modal modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>Upload Document</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <UploadModalContent context={{ report, item }} onClose={onClose} />
    </Modal.Body>
  </Modal>
);

export const InfoModal = ({ show, title, message, onClose }) => (
  <Modal show={show} onHide={onClose} backdrop="static" dialogClassName="modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{message}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>Close</Button>
    </Modal.Footer>
  </Modal>
);

export const CommentModal = ({ show, comment, onClose }) => (
  <Modal show={show} onHide={onClose} backdrop="static" dialogClassName="commentModal modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>Report Comment</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{comment || 'No Comments'}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>Close</Button>
    </Modal.Footer>
  </Modal>
);


export const ExcelPreviewModal = ({ show, data, onClose }) => {

  const handleKeyDown = (e) => {
    //There's a bug in the react-spreadsheet package
    // Where you can copy paste into read only cells
    // this prevents that
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') {
      e.preventDefault();
    }
  };

  return (
    <Modal show={show} onHide={onClose} dialogClassName="modal-lg">
      <Modal.Header closeButton>
        <Modal.Title>Excel Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{ maxHeight: '35.5rem', overflowY: 'auto' }}
          onKeyDown={handleKeyDown}
        >
          <Spreadsheet
            data={data}
            onChange={() => {}} 
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const CreateReportModal = forwardRef(
  ({ show, onClose, onSubmit, formData, setFormData, uniqueIssuers, report, item }, ref) => (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      dialogClassName="maker-create-report-modal modal-dialog-centered"
      unmountOnExit={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Create Event-Based Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CreateCreditLetterModalContent
          ref={ref}
          onClose={onClose}
          onSubmit={onSubmit}
          formData={formData}
          setFormData={setFormData}
          uniqueIssuers={uniqueIssuers}
          report={report}  // Pass report here
          item={item}      // Pass item here
        />
      </Modal.Body>
    </Modal>
  )
);